module.exports = __webpack_public_path__ + "img/flecha-siguiente_2.3ddd4b6a.svg";